import * as React from 'react';
import { TextField, MenuItem, makeStyles } from '@material-ui/core';
import { Translation } from '../../features/translations/getTranslation'

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        height: "calc(1.5em + 0.75rem + 2px)"
    },
    multiline: {
        height: 60,
        overflow: "auto"
    }
}));


const Input = (props: any) => {
    const classes = useStyles()
    var classProperties = props.className ? props.className : ''
    var type = props.type != null ? props.type : "text"
    var readonly = props.readonly ? true : false
    var required = props.required ? true : false
    var select = type === "select" ? true : false
    var variant = props.variant ? props.variant : "standard"
    var value = props.value
    var error = props.error
    var selectOptions: { Name: any; Id?: string; }[] = [];

    if (props.selectOptions != undefined) {
        props.selectOptions.forEach((selectOption: any) => {
            selectOptions.push({ ...selectOption, Name: Translation.t(selectOption.Name) });
        });
    }
    if (props.type == "number" && (isNaN(value) || value === undefined)) {
        value = ''
        error = props.error ?? "REQUIRED"
    }
    return (
        <React.Fragment>
            <TextField
                value={props.value !== "" && props.value !== null && props.value !== undefined ? value : ''}
                name={props.name}
                onKeyDown={props.onKeyDown}
                onKeyUp={props.onKeyUp}
                onChange={props.onChange}
                className={classProperties + " " + (readonly ? "boldInput " : "") + classes.root + (props.multiline ? " " + classes.multiline : "")}
                type={type}
                select={select}
                SelectProps={props.selectProps}
                label={Translation.t(props.label)}
                multiline={props.multiline ? true : false}
                minRows={props.minRows ? props.minRows : null}
                disabled={readonly}
                required={required}
                variant={variant}
                size={props.size}
                InputProps={props.InputProps}
                style={props.style}
            >
                {selectOptions ? selectOptions.map(({ Id, Name }) => (
                    <MenuItem key={Id} value={Id}>
                        {Name}
                    </MenuItem>
                )) : ''}
            </TextField>
            {error ? <p className="errorMessage">{Translation.t(error)}</p> : null}
        </React.Fragment>
    ); //ricontrollare il testo dell'error, c'� un problema di aggiornamento del componente
}

export default Input;